export default "__VITE_ASSET__Ce6V0UIY__"